import { useIntl } from 'react-intl'
import { Table } from 'src/feature/bite/component/Table'
import { getDateAndTime } from 'src/feature/bite/helpers/date'
import { useMember } from '../../hook'
import { formatMemberPhoneNumber } from 'src/feature/bite/helpers/phone'

const MemberList = ({ loading }: { loading: boolean }) => {
  const intl = useIntl()
  const { list, listFilter, listFilterSet } = useMember()

  const columns = [
    {
      key: 'fullname',
      dataIndex: 'fullName',
      title: intl.formatMessage({ id: 'MEMBER.LIST.NAME' }),
      render: (text: string, record: any) => {
        const isEmpty = record.name === '' && record.surname === ''

        if (isEmpty) {
          return <>Fast Onboarded</>
        }

        return (
          <>
            {record.name} {record.surname}
          </>
        )
      },
    },
    {
      key: 'status',
      dataIndex: 'status',
      title: intl.formatMessage({ id: 'MEMBER.LIST.STATUS' }),
      // status: true,
      render: (text: string) => {
        switch (text.toString()) {
          case '1':
            return (
              <span className='badge badge-light-success'>
                {intl.formatMessage({ id: 'GLOBAL.ACTIVE' })}
              </span>
            )
          case '2':
            return (
              <span className='badge badge-light-danger'>
                {intl.formatMessage({ id: 'GLOBAL.INACTIVE' })}
              </span>
            )
          case '3':
            return (
              <span className='badge badge-light-danger'>
                {intl.formatMessage({ id: 'GLOBAL.PREACTIVE' })}
              </span>
            )
          default:
            return <>-</>
        }
      },
    },
    {
      key: 'netpoints',
      dataIndex: 'netPoints',
      title: intl.formatMessage({ id: 'MEMBER.LIST.NET_POINTS' }),
      sorter: true,
      sortKey: 'pnt',
    },
    {
      key: 'worth',
      dataIndex: 'worth',
      title: intl.formatMessage({ id: 'MEMBER.LIST.WORTH' }),
      monetize: true,
      sorter: true,
      sortKey: 'mnyEqvlnt',
    },

    {
      key: 'savings',
      dataIndex: 'savings',
      title: intl.formatMessage({ id: 'MEMBER.LIST.SAVING' }),
      monetize: true,
      sorter: true,
      sortKey: 'svng',
    },
    {
      key: 'mobile',
      dataIndex: 'mobile',
      title: intl.formatMessage({ id: 'MEMBER.LIST.MOBILE_PHONE' }),
      render: (text: string) => {
        if (!text) return <>-</>
        return <>{formatMemberPhoneNumber(text)}</>
      },
    },
    {
      key: 'email',
      dataIndex: 'email',
      title: intl.formatMessage({ id: 'MEMBER.LIST.EMAIL' }),
      render: (text: string) => {
        if (!text) return <>-</>
        return <>{text}</>
      },
    },
    {
      key: 'enrollmentdate',
      dataIndex: 'enrollmentDate',
      title: intl.formatMessage({ id: 'MEMBER.LIST.ENROLLMENT_DATE' }),
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
    // { key: 'zip', dataIndex: 'zipCode', title: intl.formatMessage({ id: 'MEMBER.LIST.ZIP_CODE' }) },
    {
      key: 'action',
      dataIndex: 'id',
      title: intl.formatMessage({ id: 'MEMBER.LIST.ACTION' }),
      render: (id: string) => (
        <a href={`/members/${id}`}>{intl.formatMessage({ id: 'MEMBER.LIST.DETAIL' })}</a>
      ),
    },
  ]

  return (
    <Table
      loading={loading}
      dataSource={list.dataList}
      columns={columns}
      tableName={'members'}
      orderList={listFilter.orderList}
      defaultOrderList={[{ type: 2, key: 'CreatedDate' }]}
      onSort={(orderList) => {
        listFilterSet({
          ...listFilter,
          orderList: orderList,
          paging: {
            ...listFilter.paging,
            currentPageNumber: 1,
          },
        })
      }}
      pagination={{
        current: list.paging.currentPageNumber,
        pageSize: list.paging.pageSize,
        total: list.paging.totalCount,
        onChange: (page: any) => {
          const { pageSize, current } = page
          const currentPage = pageSize !== listFilter.paging.pageSize ? 1 : current

          listFilterSet({
            ...listFilter,
            paging: {
              ...listFilter.paging,
              pageSize,
              currentPageNumber: currentPage,
            },
          })
        },
      }}
    />
  )
}

export default MemberList